import React, { Component, Fragment } from 'react';
import { Jumbotron, Col, Form, Table, Button, Row } from 'react-bootstrap';
import Moment from 'moment';
import ErrorModal from '../../components/modal';

const formatTime = (time) => {
    return Moment.utc(time).local().format('DD-MM-YYYY HH:mm:ss');
}

const hexDecoder = (hex) => {
    var str = '';
    for (var i = 0; i < hex.length; i += 2) str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
}

export default class Transaction extends Component {
    constructor(props){
        super(props);
        this.state = {
            showError: false,
            error:''
        }
    }

    showErrorMsg = (msg) => {
        if(!msg) return
        // alert(msg);
        this.setState({showError: true, error:msg});
    }

    hideErrormsg = () => {
        this.setState({showError: false, error:''});
    }

    tableDetails = (all_responses) => {

        if(!all_responses) return [];
        return all_responses.map( (v, i) => (
            <tr key={i}>
                <td>{i+1}</td>
                <td>{formatTime(v.timestamp)}</td>
                <td>{v.meta.operation_succesful}</td>
                <td onClick={() => this.showErrorMsg(hexDecoder(v.meta.error_hex))}>
                    <div>
                    { !!v.meta.error_hex && hexDecoder(v.meta.error_hex)}
                    </div>
                </td>
            </tr>
        ))
    }

    render(){
    
    return (
        <Fragment>
            <Jumbotron className={'info-area mt-3'}>
                <ul>
                    <li><span className={'title'}>Id:</span> {this.props.response.id}</li>
                    <li><span className={'title'}>Create Time:</span> {formatTime(this.props.response.date_created)}</li>
                    <li><span className={'title'}>Url:</span> {this.props.response.internal_url}</li>
                    <li><span className={'title'}>retries:</span> {this.props.response.number_of_retries}</li>
                </ul>
                <p className="text-right">
                    <Button variant="primary" size="lg" disabled={this.props.doReplay} onClick={this.props.replay}>
                                {this.props.doReplay?<i className={"fas fa-spinner fa-spin"}></i>:''} Replay
                    </Button>
                </p>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Payload</Form.Label>
                            <Form.Control as="textarea" rows="12" readOnly value={JSON.stringify(this.props.response.payload, undefined, 4)}/>
                        </Form.Group>
                    </Col>
                    <Col md={6} className={'response-table'}>
                        <Form.Label>Responses</Form.Label>
                        <Table responsive striped borderless hover variant="light">
                            <thead>
                                <tr>
                                <th>#</th>
                                <th>Time</th>
                                <th>Succesful</th>
                                <th>Error</th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.tableDetails(this.props.response.all_responses)}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Jumbotron>
            <ErrorModal showMe={this.state.showError} error={this.state.error}  hideMe={this.hideErrormsg} />
        </Fragment>
        )
    }
}
